import Login from './login.vue';

export default Login;
